import path from "node:path";
import { AssetManager } from "@skaile/workspaces/asset-manager";
import { Command } from "commander";
import { bareSoftDepName, colorRef, logErr, S } from "../helpers.ts";

/**
 * Creates the `skaile why` command.
 *
 * Shows why an asset is installed by printing its dependency chain from the
 * top-level skaile.yaml requirement down to the asset.
 *
 * @returns Configured {@link Command} ready for `program.addCommand()`.
 * @docLink cli/commands/misc#why
 */
export function makeWhyCommand(): Command {
  return new Command("why")
    .description("Show why an asset is installed (dependency chain)")
    .argument("<ref>", "Asset reference (kind:name)")
    .option("--project-dir <path>", "Project directory", process.cwd())
    .action(async (ref: string, opts) => {
      const am = new AssetManager({ projectDir: path.resolve(opts.projectDir) });
      const chain = am.why(ref);
      if (chain.length === 0) {
        logErr(`${ref} not found in lock file. Run \`skaile install\` first.`);
        return;
      }
      console.log();
      console.log(S.heading("  Dependency chain"));
      for (let i = 0; i < chain.length; i++) {
        const indent = "  ".repeat(i);
        const arrow = i === 0 ? "" : "← ";
        console.log(`  ${indent}${arrow}${colorRef(chain[i])}`);
      }
      // Inferred body-link soft deps this asset pulls (report-only, distinct from
      // the typed dependency chain above).
      const softDeps = await am.softDepsOf([ref]);
      if (softDeps.length > 0) {
        console.log(
          `  ${S.dim(`also pulls (soft): ${softDeps.map((e) => bareSoftDepName(e.to)).join(", ")}`)}`,
        );
      }
      console.log();
    });
}
